import apiClient from '../apiClient';
import { POST_CONTRACTING_FILE_URL } from '../apiUrl';

const postContractingFileApi = data => {
  return apiClient.post(POST_CONTRACTING_FILE_URL, data);
};

export default postContractingFileApi;
